export type MediaItemT = {
  url: string;
  referenceUri: string;
  label: string;
};